import axios from 'axios'
import axiosAuthRequired from './axiosAuthRequired'

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem('client_credentials')
  if (clientCredentials) {
    headers['Authorization'] = 'Bearer ' + clientCredentials
  }

  return headers
}

export const fetchFortniteMetaNews = () => {
  return axios({
    method: 'get',
    url: '/api/v2/game-meta/fortnite/meta-news'
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchFortniteVoteable = (id) => {
  return axios({
    method: 'get',
    url: '/api/v2/community/voteable/fnbr_patch_note/' + id + '/votes',
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const postFortniteVoteableVote = (payload) => {
  let body = new FormData()
  body.append('action', payload.vote)

  return axiosAuthRequired({
    method: 'post',
    url: '/api/v2/community/voteable/fnbr_patch_note/' + payload.root_id + '/votes',
    data: body,
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchFortniteMetaComments = (id) => {
  let url = '/api/v2/community/discussion/fnbr_patch_note/' + id
  return axiosAuthRequired({
    method: 'get',
    url: url,
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const postFortniteMetaCommentVote = (payload) => {
  let url = '/api/v2/community/voteable/comment/' + payload.root_id + '/votes'

  let body = new FormData()
  body.append('action', payload.vote)

  return axiosAuthRequired({
    method: 'post',
    url: url,
    data: body,
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const postFortniteMetaComment = (payload) => {
  let url = '/api/v2/community/discussion/fnbr_patch_note/' + payload.root_id + '/comments'

  let body = new FormData()
  body.append('comment', payload.comment)

  if (payload.parent_comment_id) {
    body.append('parent_comment_id', payload.parent_comment_id)
  }
  if (payload.language) {
    body.append('language', payload.language)
  }

  return axiosAuthRequired({
    method: 'post',
    url: url,
    data: body,
    headers: getAuthHeaders()
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchFortniteMetaWeapons = () => {
  let url = '/api/v2/game-resources/fortnite/static-data/weapons'
  return axios({
    method: 'get',
    url: url
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}

export const fetchFortniteMetaTierList = () => {
  let url = '/api/v2/game-meta/fortnite/weapons/tier-list'
  return axios({
    method: 'get',
    url: url
  }).then((response) => {
    return response.data
  }).catch((error) => {
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/api/fortnite.js